import React from "react";
const sohbetler2Large = require('../../../assets/books/kapaklar/sohbetler_2_600.jpg');
const sohbetler2Mini = require('../../../assets/books/kapaklar/sohbetler_2-300.jpg');
export const Sohbetler2Description = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img
                    src={sohbetler2Large}
                    alt="Aşka Meşke Semaya Yolculuk"
                    srcSet={`${sohbetler2Mini} 300w, ${sohbetler2Large} 600w`}
                    sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>
            <p>
                Geçmişten günümüze, Arabıyla, Acemiyle, beyazıyla siyahıyla, kadınıyla, erkeğiyle; inançtan bilince, ibadetten ahlâka, ticaretten sosyal ilişkilere,
                kültürden medeniyete Müslümanların ortak yaşam tarzlarını belirleyen, onları aynı duygu ve düşüncelerde birleştirerek tek bir ümmet kılan şey sünnettir.
            </p>
            <p>
                Hz. Peygamber’in yolu ve yöntemi olan sünnet, teorisi ve pratiğiyle tam bir ‘medeniyet projesi’dir.
                Allah Resûlü’nün cahili ve bedevi insanları medeni bir hayata alıştırarak örnek bir toplum oluşturması sünnetin bir ‘medeniyet projesi’ olduğunun açık göstergesidir.
                Öyle ki bu toplumun içinde yetiştiği “Yesrib” şehri “medeniyet”in beşiği haline gelerek aynı kökten gelen “Medine” ismiyle adlandırılmıştır.
            </p>
            <p>Sünnet olmadan ümmet olmaz, ümmet olmadan millet olmaz.</p>
        </div>
    )
}
export const Sohbetler2SummaryDescription = (props: any) => {
    return (
        <p>
            Geçmişten günümüze, Arabıyla, Acemiyle, beyazıyla siyahıyla, kadınıyla, erkeğiyle; inançtan bilince, ibadetten ahlâka, ticaretten sosyal ilişkilere,
            kültürden medeniyete Müslümanların ortak yaşam tarzlarını belirleyen, onları aynı duygu ve düşüncelerde birleştirerek tek bir ümmet kılan şey sünnettir.
            Hz. Peygamber’in yolu ve yöntemi olan sünnet, teorisi ve pratiğiyle tam bir ‘medeniyet projesi’dir.
            Allah Resûlü’nün cahili ve bedevi insanları medeni bir hayata alıştırarak örnek bir toplum oluşturması sünnetin bir ‘medeniyet projesi’ olduğunun açık göstergesidir.
            Öyle ki bu toplumun içinde yetiştiği “Yesrib” şehri “medeniyet”in beşiği haline gelerek aynı kökten gelen “Medine” ismiyle adlandırılmıştır.
        </p>
    )
}